import { setTokenManager } from '@billx/api';
import {
  getCustomerAuthTokens,
  getUserAuthTokens,
  removeCustomerAuthTokens,
  removeUserAuthTokens,
  setCustomerAuthTokens,
  setUserAuthTokens,
} from '@billx/utils';

import { getDeviceId } from './deviceManager';

setTokenManager({
  getUserTokens: () => (getUserAuthTokens() as any) || {},
  setUserTokens: (t) => setUserAuthTokens(t),
  removeUserTokens: () => removeUserAuthTokens(),
  getCustomerTokens: (bId) => (getCustomerAuthTokens(bId) as any) || {},
  setCustomerTokens: (bId, t) => setCustomerAuthTokens(bId, t),
  removeCustomerTokens: (bId) => removeCustomerAuthTokens(bId),
  getBusinessId: () => sessionStorage.getItem('business'),
  setBusinessId: (id: string) => sessionStorage.setItem('business', id),
  logger: {
    log: console.log,
    warn: console.warn,
    error: console.error,
    debug: console.debug,
    info: console.info,
    logWSEvent: console.log,
    logWSError: console.error,
    logUserAction: () => {
      return;
    },
  },
  showNotification: () => {},
  onAuthError: () => window.location.reload(),
  getDeviceId: async () => getDeviceId(),
});
